import React from "react";
import { classes, style } from "typestyle";
import fontSize from "../../styles/fontSize";

const sizes: { [k in keyof typeof fontSize]: string } = {
  xs: classes(fontSize.xs, style({ fontWeight: 600 })),
  sm: classes(fontSize.sm, style({ fontWeight: 600 })),
  base: classes(fontSize.base, style({ fontWeight: 700 })),
  lg: classes(fontSize.lg, style({ fontWeight: 800 })),
  xl: classes(fontSize.xl, style({ fontWeight: 800 })),
  xl2: classes(fontSize.xl2, style({ fontWeight: 800 })),
  xl3: classes(fontSize.xl3, style({ fontWeight: 900 })),
  xl4: classes(fontSize.xl4, style({ fontWeight: 900 })),
  xl5: classes(fontSize.xl5, style({ fontWeight: 900 })),
};

type HeadingProps = {
  color?: string;
  size?: keyof typeof sizes;
  className?: string;
  children?: React.ReactNode;
};

const Heading: React.FC<HeadingProps> = ({
  children,
  color = "inherit",
  className,
  size = "xl",
}) => (
  <div className={classes(className, sizes[size])} style={{ color }}>
    {children}
  </div>
);

export default Heading;
